import React from 'react';
import ShowDeliveryTimeProperties from "./ShowDeliveryTimeProperties";
import { useStyles } from "./ShowDeliveryTime.style";
import { useI18nContext } from "../../../contexts/I18nContext";
import clsx from "clsx";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ScheduleIcon from '@mui/icons-material/Schedule';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const ShowDeliveryTime: React.FC<ShowDeliveryTimeProperties> = ({
    deliveryTime,
    unit = "days",
    className = '',
}) => {

    const i18n = useI18nContext();
    const classes = useStyles();

    const hasDeliveryTime = deliveryTime !== null && deliveryTime !== undefined;

    return (
        <div className={clsx(
            classes.delivery_container,
            !hasDeliveryTime && classes.undefined,
            className
        )}>
            
            {/* Ícone principal */}
            <div className={classes.icon}>
                {hasDeliveryTime ? (
                    <LocalShippingIcon fontSize="small" />
                ) : (
                    <HelpOutlineIcon fontSize="small" />
                )}
            </div>

            {/* Conteúdo */}
            <div className={classes.content}>
                <span className={classes.label}>
                    {i18n.translate("DELIVERY_TIME")}
                </span>

                {hasDeliveryTime ? (
                    <div className={classes.value}>
                        <ScheduleIcon className={classes.time_icon} />
                        <strong>{deliveryTime}</strong>
                        <span className={classes.unit}>
                            {i18n.translate(unit.toUpperCase())}
                        </span>
                    </div>
                ) : (
                    <div className={classes.undefined_value}>
                        {i18n.translate("DELIVERY_TIME_NOT_DEFINED")}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ShowDeliveryTime;
